import { useShowsQuery } from "@src/queries/showQueries";
import { IShowRecord } from "@src/types/show";
import { RoleType } from "@src/types/user";

interface UseMyShowsResult {
  myShows: IShowRecord[];
  loadingMyShows: boolean;
  myShowsFetchingError: any;
  refetchMyShows: () => void;
}

export const useMyShows = ({
  curatorId,
  roleType = "curator",
  searchText,
  isMoodFactory = false,
}: {
  curatorId: number;
  searchText: string;
  roleType?: RoleType;
  isMoodFactory?: boolean;
}): UseMyShowsResult => {
  const { data, isLoading, error, refetch, isFetching } = useShowsQuery({
    curatorId,
    roleType,
    searchText,
    isMoodFactory,
  });
  if (
    (!curatorId || curatorId === 0) &&
    roleType !== "admin" &&
    roleType !== "manager"
  ) {
    return {
      myShows: [],
      loadingMyShows: false,
      myShowsFetchingError: "Curator ID is required",
      refetchMyShows: refetch,
    };
  }

  return {
    myShows: data?.data.data || [],
    loadingMyShows: isLoading || isFetching,
    myShowsFetchingError: error,
    refetchMyShows: refetch,
  };
};
